import React from 'react';

let enableGATracking = false;
let isUATrackingId = false;

const gtag = (...args) => {
	if (typeof window !== 'undefined') {
		if (typeof window.gtag === 'undefined') {
			window.dataLayer = window.dataLayer || [];
			window.gtag = function gtag() {
				window.dataLayer.push(arguments);
			};
		}

		window.gtag(...args);
	}
};

const loadGTag = (googleAnalyticsCode) => {
	const gtagJs = document.createElement('script');
	gtagJs.src = `https://www.googletagmanager.com/gtag/js?id=${googleAnalyticsCode}`;
	gtagJs.async = true;
	gtagJs.onload = () => {
		gtag('js', new Date());
		gtag('config', googleAnalyticsCode);
	};
	document.body && document.body.appendChild(gtagJs);
};

const initAnalyticsTracking = ({ googleAnalyticsAdminCode }) => {
	
	if (googleAnalyticsAdminCode) {
		loadGTag(googleAnalyticsAdminCode);
		enableGATracking = true;
		isUATrackingId = googleAnalyticsAdminCode.startsWith('UA-');	// Universal Analytics tracking id
	}
	else {
		enableGATracking = false;
	}
};

const trackPageView = (page) => {
	// Manually send page views for Universal Analytics tracking IDs only.
	// GA4 Measurement IDs send page views automatically as long as "Enhanced measurement" => "Page views" => "Page changes based on browser history events" is enabled
	if (enableGATracking && isUATrackingId) {
		gtag('event', 'page_view', { page_path: page });
	}
};

export default {
	initAnalyticsTracking,
	trackPageView
};

export const withAnalytics = Component =>
	class WithAnalytics extends React.Component {
		componentDidMount() {
			const page = this.props.location.pathname;
			this.trackPage(page);
		}

		componentWillReceiveProps(nextProps) {
			const currentPage = this.props.location.pathname;
			const nextPage = nextProps.location.pathname;

			// trigger analytics tracking after franchisor details (GoogleAnalyticsAdminCode, etc.) are loaded
			const currentFranchisor = this.props.franchisor;
			const nextFranchisor = nextProps.franchisor;

			if (currentPage !== nextPage || (nextFranchisor && currentFranchisor.id !== nextFranchisor.id)) {
				this.trackPage(nextPage);
			}
		}

		trackPage(page) {
			trackPageView(page);
		}

		render() {
			return <Component {...this.props} />;
		}
	};